import { IconContent } from '@icons';

export const paper: IconContent = {
    md: '<path fill-rule="evenodd" d="M4 18a2 2 0 0 0 2 2h11.5a2.5 2.5 0 0 0 2.5-2.5V4H7v14a1 1 0 1 1-2 0V6H4v12ZM8 5v13c0 .364-.097.706-.268 1H17.5a1.5 1.5 0 0 0 1.5-1.5V5H8Zm6 2h4v1h-4V7Zm4 2h-4v1h4V9Zm-4 2h4v1h-4v-1Zm4 2h-4v1h4v-1Zm-9 2h9v1H9v-1Zm1-7h2v5h-2V8ZM9 7h4v7H9V7Z" />',
};
